import React from "react";
import { useIntl } from "react-intl";

import { TextField } from "@material-ui/core";

import { common } from "../../../messages";
import { useBmapi } from "../../../utils/bmapi-context";

export function LastName({ value, onChange }) {
  const intl = useIntl();
  const { bmapi } = useBmapi();

  return (
    <TextField
      fullWidth
      label={intl.formatMessage(common.lastName)}
      margin="normal"
      name="last_name"
      onChange={onChange}
      required={bmapi.settings.profileRequired.includes("last_name")}
      value={value}
    />
  );
}
